import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { getBusinessSizeTable } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/businessSize',
  initialState: {
    isLoading: true,
    topCompaniesQuantity: undefined,
    ids: [],
    data: {},
  },
  reducers: {
    filterTable: (state, { payload }) => {
      state.ids = Object.keys(state.data).filter(
        (id) => state.data[id].businessSize === payload,
      )
    },
    resetTable: (state) => {
      state.ids = Object.keys(state.data)
    },
    resetStore: (state) => {
      state.isLoading = true
      state.topCompaniesQuantity = undefined
      state.ids = []
      state.data = {}
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getBusinessSizeTable.pending, (state) => {
      state.isLoading = true
      state.topCompaniesQuantity = undefined
      state.ids = []
      state.data = {}
    })
    builder.addCase(
      getBusinessSizeTable.fulfilled,
      (state, { payload = {} }) => {
        state.isLoading = false

        const { data = [], totalCompanies } = payload
        const formatData = data.map((item, index) => ({
          ...item,
          id: index + 1,
          businessSize: item.companySize,
        }))
        const ids = formatData.map((item) => item.id)

        state.topCompaniesQuantity = totalCompanies
        state.ids = ids
        state.data = keyBy(formatData, 'id')
      },
    )
    builder.addCase(getBusinessSizeTable.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })
  },
})

export const selectIds = (state) => state[slice.name].ids
export const selectData = (state) => state[slice.name].data
export const selectCellData = (rowId, colId) => (state) =>
  state[slice.name].data[rowId][colId]
export const selectTopCompaniesQuantity = (state) =>
  state[slice.name].topCompaniesQuantity
export const selectIsLoading = (state) => state[slice.name].isLoading

export const { filterTable, resetTable, resetStore } = slice.actions

register(slice.name, slice.reducer)
